import { get } from 'lodash-es';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { dateInitFormats, parseCustomFormatToDate } from '@common/Util';

const DateTimePickerInput = ({
  field = {},
  form: { errors, touched } = {},
  required = false,
  isManualInputDisabled = false,
  onChange = () => {},
  ...rest
}) => {
  const isError = Boolean(get(touched, field?.name) && get(errors, field?.name));
  const errorMsg = get(errors, field?.name);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DateTimePicker
        showToolbar
        slotProps={{
          openPickerIcon: {
            color: 'primary'
          },
          textField: (props) => ({
            onBlur: field?.onBlur,
            required: required,
            name: field?.name,
            size: 'small',
            error: isError,
            helperText: errorMsg,
            InputProps: { ...props.inputProps, ...props.InputProps },
            onKeyDown: (e) => {
              isManualInputDisabled && e.preventDefault();
            },
            FormHelperTextProps: { ['data-test-id']: field?.name }
          })
        }}
        {...rest}
        onChange={onChange}
        value={parseCustomFormatToDate(field?.value || rest?.value, [
          dateInitFormats.serverResponseDateTimeFormat,
          dateInitFormats.dateTimePickerFormat
        ])}
      />
    </LocalizationProvider>
  );
};

export default DateTimePickerInput;
